export default __webpack_public_path__ + "static/media/302.0bbe7775.png";